import React from 'react';
import { Card, Table, Badge, Button, Spinner } from 'react-bootstrap';
import Pagination from '../../components/UI/Pagination';

/**
 * 감사로그 목록 뷰
 */
const AuditLogListView = ({ 
  logs, 
  loading, 
  pagination, 
  onPageChange, 
  onShowDetail 
}) => {
  
  const formatTimestamp = (timestamp) => {
    if (!timestamp) return '-';
    return new Date(timestamp).toLocaleString('ko-KR', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit'
    });
  };

  const getSeverityBadge = (severity) => {
    const variants = {
      'CRITICAL': 'danger',
      'HIGH': 'warning',
      'MEDIUM': 'info',
      'LOW': 'secondary'
    };
    return variants[severity] || 'secondary';
  };

  const getResultBadge = (result) => {
    const variants = {
      'SUCCESS': 'success',
      'FAILURE': 'danger',
      'WARNING': 'warning',
      'BLOCKED': 'dark'
    };
    return variants[result] || 'secondary';
  };

  const getCategoryLabel = (category) => {
    const labels = {
      'ACCESS_CONTROL': '접근 제어',
      'DATA_PROTECTION': '데이터 보호',
      'SYSTEM_SECURITY': '시스템 보안',
      'AUDIT_MONITORING': '감사 모니터링',
      'USER_MANAGEMENT': '사용자 관리',
      'BUSINESS_LOGIC': '비즈니스 로직',
      'SECURITY_VIOLATION': '보안 위반',
      'BIOMETRIC_AUTH': '생체 인증',
      'MEDICAL_DATA': '의료 데이터',
      'BIOMETRIC_MANAGEMENT': '생체정보 관리'
    };
    return labels[category] || category;
  };


  return (
    <Card>
      <Card.Header>
        <strong>감사로그 목록</strong>
        <span className="text-muted ms-2">(총 {pagination.totalItems}개)</span>
      </Card.Header>
      <Card.Body>
        {loading ? (
          <div className="text-center py-5">
            <Spinner animation="border" role="status">
              <span className="visually-hidden">로딩 중...</span>
            </Spinner>
          </div>
        ) : logs.length === 0 ? (
          <div className="text-center py-5 text-muted">
            조회된 감사로그가 없습니다.
          </div>
        ) : (
          <div className="table-responsive">
            <Table hover size="sm">
              <thead className="table-light">
                <tr>
                  <th style={{ width: '50px' }}>ID</th>
                  <th style={{ width: '160px' }}>시간</th>
                  <th style={{ width: '120px' }}>카테고리</th>
                  <th>활동 유형</th>
                  <th style={{ width: '90px' }}>심각도</th>
                  <th style={{ width: '90px' }}>결과</th>
                  <th style={{ width: '120px' }}>사용자</th>
                  <th style={{ width: '130px' }}>IP</th>
                  <th style={{ width: '80px' }}>작업</th>
                </tr>
              </thead>
              <tbody>
                {logs.map((log) => (
                  <tr key={log.id}>
                    <td className="text-muted small">{log.id}</td>
                    <td className="text-nowrap small">{formatTimestamp(log.timestamp)}</td>
                    <td>
                      <Badge bg="info" className="w-100 text-white">
                        {getCategoryLabel(log.category)}
                      </Badge>
                    </td>
                    <td className="small">{log.activity_type}</td>
                    <td>
                      <Badge bg={getSeverityBadge(log.severity)} className="w-100 text-white">
                        {log.severity}
                      </Badge>
                    </td>
                    <td>
                      <Badge bg={getResultBadge(log.result)} className="w-100 text-white">
                        {log.result}
                      </Badge>
                    </td>
                    <td className="small">{log.username || '-'}</td>
                    <td className="small text-muted">{log.source_ip || '-'}</td>
                    <td>
                      <Button
                        size="sm"
                        variant="outline-primary"
                        onClick={() => onShowDetail(log)}
                      >
                        상세
                      </Button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>
        )}
      </Card.Body>
      <Card.Footer className="d-flex justify-content-center">
        <Pagination 
          currentPage={pagination.currentPage} 
          totalCount={pagination.totalItems} 
          pageSize={pagination.itemsPerPage} 
          pageBlock={5}
          onPageChange={onPageChange} 
        />
      </Card.Footer>
    </Card>
  );
};

export default AuditLogListView;
